<template>
  <v-row class="pt-3">
    <v-col cols="6" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <v-text-field
        v-model="keywordWorkName"
        chips
        outlined
        label="ชื่อส่วนงาน"
        placeholder="ค้นหา ชื่อส่วนงาน"
        class="mt-2"
        dense
        v-on:keyup.enter="searchFilterData(), page=1"
      >
        <template #selection="{ item }">
          <v-chip color="#0370B7 !important">
            <span class="filter-chip_department">{{item}}</span>
          </v-chip>
        </template>
      </v-text-field>
    </v-col>
    <v-col cols="6" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <v-select
        v-model="keywordHeaderName"
        :items="itemHeaderName"
        outlined
        label="สายบังคับบัญชา"
        placeholder="ค้นหา สายบังคับบัญชา"
        class="mt-2"
        dense
      >
      </v-select>
    </v-col>
    <v-col cols="6" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <v-select
        v-model="keywordCompanyName"
        :items="itemCompanyName"
        outlined
        label="ชื่อย่อบริษัท"
        placeholder="ค้นหา ชื่อย่อบริษัท"
        class="mt-2"
        dense
      >
      </v-select>
    </v-col>
    <v-col cols="6" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <v-select
        v-model="keywordGroupCompanyName"
        :items="itemGroupCompanyName"
        outlined
        label="ชื่อเครือ"
        placeholder="ค้นหา ชื่อเครือ"
        class="mt-2"
        dense
      >
      </v-select>
    </v-col>
    <v-col cols="12" lg="4" md="6" sm="6" class="pt-0 pb-0 d-flex align-end">
      <v-row class="pl-3 pr-3" style="margin-bottom: 14px;">
        <v-btn class="btn-search-dep mr-5" style="min-height: 38px;" @click="searchFilterData()">ค้นหา</v-btn>
        <v-btn class="btn-reset-dep" style="min-height: 38px;" @click="resetFilterData()">ล้างข้อมูล</v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  name: 'filter-section',
  data () {
    return {
      keywordWorkName: '',
      keywordHeaderName: [],
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      keywordUserName: [],
      filterData: {
        name: '',
        header: [],
        companyName: [],
        groupCompany: [],
        limit: 50,
        page: 1
      },
      itemSmall: ['INET', 'OGS'],
      itemLineWorkName: [],
      itemHeaderName: [],
      itemUserName: [],
      itemGroupCompanyName: [],
      itemCompanyName: [],
      itemsSmallDep: [{
        id: 0,
        value: 0,
        label: 'INET'
      }, {
        id: 1,
        value: 1,
        label: 'MANDALA'
      }]
    }
  },
  watch: {
    keywordWorkName: function (val) {
      if (val.length) {
        this.filterData.name = val
        // console.log('Work Name', this.filterData.name)
      }
      // EventBus.$emit('detailCompany', nodeId)
    },
    keywordHeaderName: function (val) {
      if (val.length) {
        this.filterData.managementName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    }
  },
  mounted () {
    EventBus.$on('getSection', this.getSelectData)
    EventBus.$on('selectSection', this.getSelectValue)
  },
  methods: {
    getSelectValue (value) {
      this.itemHeaderName = value.orgChartHeaderName
      this.itemCompanyName = value.companyShortNameEng
      this.itemGroupCompanyName = value.groupCompanyName
    },
    getSelectData (data) {
      this.itemSmall = data.companyShortName
      this.itemHeaderName = data.managementHeader
      this.itemUserName = data.userName
    },
    resetFilterData () {
      this.keywordWorkName = ''
      this.keywordHeaderName = []
      this.keywordCompanyName = []
      this.keywordUserName = []
      this.filterData = {
        name: '',
        header: [],
        companyName: [],
        groupCompany: [],
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterSection', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        name: this.keywordWorkName,
        header: [this.keywordHeaderName],
        companyName: [this.keywordCompanyName],
        groupCompany: [this.keywordGroupCompanyName],
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterSection', this.filterData)
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
</style>
